import type { FeatureGradientKey } from './marketplace-tokens'

// =============================================================================
// Marketplace fixtures.
//
// This file holds the bits of marketplace content that DON'T come from the
// catalog/queries today:
//
//   - Feature hero cards (3 gradient slots — no DB analog for editorial yet)
//   - Page strings (eyebrow line copy, search placeholder)
//   - Axis pill labels (counts are derived from real data in MarketplacePage)
//
// Channel and Command card content comes from `lib/connectors/get-catalog`
// and `lib/marketplace/queries`. Per-card colors/icons come from
// `marketplace-tokens.ts`.
// =============================================================================

export interface FeatureFixture {
  id: string
  channelKey: string
  tag: string
  kicker: string
  titleLines: [string, string]
  body: string
  meta?: string
  logos?: string[]
  gradientKey: FeatureGradientKey
}

export const features: FeatureFixture[] = [
  {
    id: 'streaming',
    channelKey: 'tv',
    tag: 'New',
    kicker: 'Streaming',
    titleLines: ['Stream where', 'your buyers live.'],
    body: 'Peacock, Paramount+, Disney+, Max, Hulu, Roku, YouTube TV — all in one buy.',
    logos: ['P', 'D+', 'M', '+4'],
    gradientKey: 'streaming',
  },
  {
    id: 'linear-tv',
    channelKey: 'tv',
    tag: 'Spotlight',
    kicker: 'Linear TV',
    titleLines: ['Local broadcast,', 'at national speed.'],
    body: 'Nexstar, Sinclair, Tegna, Gray, Hearst. One buy, 200+ markets, weekly post-logs.',
    meta: '5 station groups · 210 markets',
    gradientKey: 'linearTv',
  },
  {
    id: 'search',
    channelKey: 'search',
    tag: 'Most installed',
    kicker: 'Search',
    titleLines: ['High-intent search,', 'operated by chat.'],
    body: 'Google, Bing, plus AI-search surfaces. Negatives, RLSA, brand defense — automated.',
    meta: '6 subchannels · live',
    gradientKey: 'search',
  },
]

export const searchPlaceholder = 'Search channels, commands, prompts…'
